export const OVERALL = "overall"
export const MODELS = "models"
export const CLIENTS = "clients"
export const EMPLOYEES = "employees"
